import { __assign } from './external/tslib/tslib.es6.js';
import * as React from 'react';

var SvgBellOutline = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 18H2l3-6V9.71c0-2.28 1.29-4.35 3.32-5.37L11 3V2h2v1l2.68 1.34A6.002 6.002 0 0 1 19 9.71V12l3 6ZM6.78 12.89 5.23 16h13.52l-1.55-3.11-.21-.42V9.71c0-1.53-.85-2.9-2.21-3.58L12.52 5h-1.06L9.2 6.13a3.99 3.99 0 0 0-2.21 3.58v2.76l-.21.42Z", fill: "currentColor" }),
    React.createElement("path", { d: "M13 19.5V19h2v1.83l-3 1.25-3-1.25V19h2v.5l1 .42 1-.42Z", fill: "currentColor" }))); };

export { SvgBellOutline as default };
